<template>
  <ResponsiveLayout :progress="progress">
    <template
      v-if="canGoBack"
      #header_start
    >
      <ButtonBack @click="navigateBack" />
    </template>
    <template #header_end><HeaderHelp /></template>
    <form
      id="phone-input-form"
      autocomplete="off"
      class="kds-main-wrapper"
      data-qa="phone-input"
      novalidate
      @submit.prevent="submit"
    >
      <div class="kds-content-block">
        <p class="kds-typography-title-xlarge">
          {{ $t('eu__phone_input__title') }}
        </p>
        <p class="kds-typography-paragraph-large">
          {{ $t('eu__phone_input__description') }}
        </p>
      </div>
      <div class="kds-content-block">
        <PhonenumberField
          :country="phoneNumberCountryCode"
          :label="$t('eu__sign_up__phone_number__required')"
          data-qa="phone-number"
          v-bind="fieldAttrs.phoneNumber"
        />
      </div>
    </form>
    <template #actions>
      <BaseButton
        :text="$t('generic_action_continue')"
        data-qa="submit"
        form="phone-input-form"
        v-bind="submitAttrs"
      />
    </template>
  </ResponsiveLayout>
</template>

<script setup>
import { computed, ref } from 'vue'
import useUserStore from '@shared/stores/useUserStore.js'
import * as apiRequest from '@shared/api-endpoints'
import useForm from '@shared/composables/useForm.js'
import ResponsiveLayout from '@shared/components/ResponsiveLayout.vue'
import HeaderHelp from '@eu/app/components/HeaderHelp.vue'
import BaseButton from '@shared/components/BaseButton.vue'
import ButtonBack from '@shared/components/ButtonBack.vue'
import PhonenumberField from '@shared/components/form/PhonenumberField.vue'
import useOnboardingProgress from '@eu/app/composables/useOnboardingProgress.js'
import useNavigation from '@eu/app/composables/useNavigation'
import ROUTE from '@eu/app/router/appModule/names'
const userStore = useUserStore()
const { progress } = useOnboardingProgress()
const { navigateNext, navigateBack, canGoBack } = useNavigation(
  ROUTE.PHONE_INPUT,
  ROUTE.PHONE_INPUT_INSURANCE,
  ROUTE.PHONE_INPUT_PRESCRIBER,
  ROUTE.PHONE_INPUT_OUTREACH,
  ROUTE.PHONE_INPUT_OUTREACH_CONFIRMATION,
  ROUTE.PHONE_INPUT_OUTREACH_MANUAL,
)

const form = ref({
  phoneNumber: '',
})

const { fieldAttrs, submitAttrs, submit } = useForm(
  form,
  ref({
    phoneNumber: { validations: ['required', 'phone'] },
  }),
  {
    onSubmit: async () => {
      await apiRequest.setUserProfile({
        phoneNumber: form.value.phoneNumber,
      })

      try {
        await apiRequest.updateUserConsents([
          { type: 'web_health_data', given: true },
        ])
      } catch {
        // consent recording is non-critical; proceed regardless
      }
    },
    onSuccess: async () => {
      // in-app users are returned into the app by the download-link guard
      await navigateNext()
    },
    onError: () => {},
  },
)

const phoneNumberCountryCode = computed(
  () => form.value.phoneNumber?.countryCode || userStore.country,
)
</script>
